import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Polyline, useMap } from "react-leaflet";
import { useParams } from "react-router-dom";
import L from "leaflet";
import axios from "axios";
import { URL } from "../config";


const technicianIcon = L.divIcon({
  html: `<div style="
    width:14px; height:14px; background:green;
    border-radius:50%;
    box-shadow:0 0 10px rgba(0,128,0,0.8);
  "></div>`,
  className: "",
  iconSize: [20, 20],
});

const customerIcon = L.divIcon({
  html: `<div style="
    width:14px; height:14px; background:red;
    border-radius:50%;
    box-shadow:0 0 10px rgba(255,0,0,0.8);
  "></div>`,
  className: "",
  iconSize: [20, 20],
});


function FollowMap({ position }) {
  const map = useMap();
  useEffect(() => {
    if (position && map) {
      map.setView(position, map.getZoom(), { animate: true });
    }
  }, [position, map]);
  return null;
}


function MapArrows() {
  const map = useMap();
  const d = 200;

  const btnStyle = {
    width: 40,
    height: 40,
    margin: 4,
    fontSize: 18,
    cursor: "pointer",
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 20,
        right: 20,
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: "rgba(255,255,255,0.85)",
        padding: 6,
        borderRadius: 8,
      }}
    >
      <button style={btnStyle} onClick={() => map.panBy([0, -d])}>⬆</button>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <button style={btnStyle} onClick={() => map.panBy([-d, 0])}>⬅</button>
        <button style={btnStyle} onClick={() => map.panBy([d, 0])}>➡</button>
      </div>

      <button style={btnStyle} onClick={() => map.panBy([0, d])}>⬇</button>
    </div>
  );
}


export default function RouteTrackingMap() {
  const { id } = useParams();

  const [technicianPos, setTechnicianPos] = useState(null);
  const [customerPos, setCustomerPos] = useState(null);
  const [route, setRoute] = useState(null);

 
  useEffect(() => {
    if (!id) return;

    axios
      .get(`${URL}/installations/${id}`)
      .then(async (res) => {
        const data = res.data.data;
        const {
          latitude,
          longitude,
          technicianLatitude,
          technicianLongitude,
        } = data;

        if (latitude && longitude) {
          setCustomerPos([Number(latitude), Number(longitude)]);
        }

        if (technicianLatitude && technicianLongitude) {
          setTechnicianPos([
            Number(technicianLatitude),
            Number(technicianLongitude),
          ]);
        }

    
        if (latitude && longitude && technicianLatitude && technicianLongitude) {
          const techPos = [Number(technicianLatitude), Number(technicianLongitude)];
          const custPos = [Number(latitude), Number(longitude)];

          try {
            const osrmUrl = `https://router.project-osrm.org/route/v1/driving/${techPos[1]},${techPos[0]};${custPos[1]},${custPos[0]}?overview=full&geometries=geojson`;
            const routeRes = await fetch(osrmUrl);
            const routeData = await routeRes.json();

            if (routeData.routes?.length) {
              const coords = routeData.routes[0].geometry.coordinates.map(
                ([lng, lat]) => [lat, lng]
              );
              setRoute(coords);
            }
          } catch (err) {
            console.error("Route fetch error:", err);
          }
        }
      })
      .catch((err) => console.error("Installation fetch failed:", err));
  }, [id]);

  if (!customerPos) return <div>Loading map...</div>;

  return (
    <div style={{ position: "relative" }}>
      <MapContainer
        center={technicianPos || customerPos}
        zoom={11}
        style={{ height: "100vh", width: "100%" }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

        {technicianPos && (
          <Marker position={technicianPos} icon={technicianIcon} />
        )}

        {customerPos && (
          <Marker position={customerPos} icon={customerIcon} />
        )}

        {route && <Polyline positions={route} color="blue" />}

        <FollowMap position={technicianPos} />
        <MapArrows />
      </MapContainer>
    </div>
  );
}
